module.exports = __webpack_public_path__ + "img/builder-25.eeae2a5d.jpg";